<template>
    <div>
      <bank-list></bank-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  